import { ErrorLogComponent } from '@cian/error-log-component';

import { FC, PropsWithChildren } from 'react';

import { useApplicationContext } from 'shared/serp/containers/ApplicationContext';

/**
 * Ошибка одной карточки или баннера без этой обёртки доходит до общего ErrorLogComponent
 * и гасит весь список офферов.
 */
export const BlockErrorBoundary: FC<PropsWithChildren> = ({ children }) => {
  const { logger } = useApplicationContext();

  return <ErrorLogComponent logger={logger}>{children}</ErrorLogComponent>;
};
